import React, { useState, useEffect } from "react";
import axios from "axios";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import Navbar from "./Header";
import Loader from "react-loader-spinner";
import "./Style.css";
import { DecryptED } from "../DecryptJS/Decrypt";

const configUrl = "https://marcopolo.prisms.in";
const token = "#$laksdfnlknoea#$@$%^&%$";

const DownLoadMultiple = () => {
  const { sid, idesign } = useParams();
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [classID, setClassID] = useState("");
  const [std, setStd] = useState("");
  const [divID, setDivID] = useState("");
  const [divName, setDivName] = useState("");
  const [imageData, setImageData] = useState([]);
  const [studentCount, setStudentCount] = useState(null);
  const [totalIdCards, setTotalIdCards] = useState(null);

  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [rendered, setRendered] = useState(false);

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const { data } = await axios.post(
          `${configUrl}/api/tscommon/getallclass`,
          { sid: DecryptED(sid) },
          { headers: { Authorization: token } }
        );
        setClasses(data || []);
      } catch (err) {
        console.error("Error fetching classes:", err);
      }
    };
    fetchClasses();
  }, [sid]);

  useEffect(() => {
    if (!classID) return;

    const fetchDivisions = async () => {
      try {
        const { data } = await axios.post(
          `${configUrl}/api/tscommon/getalldiv`,
          { class_id: classID, sid: DecryptED(sid) },
          { headers: { Authorization: token } }
        );
        setDivisions(data || []);
      } catch (err) {
        console.error("Error fetching divisions:", err);
      }
    };

    fetchDivisions();
  }, [classID, sid]);

  const downloadImagesAsZip = async () => {
    const zip = new JSZip();
    setDownloading(true);

    try {
      await Promise.all(
        imageData.map(async (img) => {
          if (!img.idcard_image) return;

          const url = img.idcard_image;
          const parts = url.split("/");
          let studentName = decodeURIComponent(parts[parts.length - 2] || "student");
          studentName = studentName.replace(/}/g, "").trim().replace(/\s+/g, "-");
          const filename = `${studentName}.png`;
          const response = await axios.get(url, { responseType: "blob" });
          zip.file(filename, response.data);
        })
      );

      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, `class_${std}_div_${divName}.zip`);
    } catch (err) {
      console.error("Error zipping images:", err);
    } finally {
      setDownloading(false);
    }
  };

  const generateIdCards = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(
        `${configUrl}/api/idcard/parent/idcards`,
        {
          sid: DecryptED(sid),
          design_id: idesign,
          classid: [classID],
          div: [divID],
        },
        { headers: { Authorization: token } }
      );

      setImageData(data);
      setStudentCount(data.length);
      setTotalIdCards(data.filter((img) => img.idcard_image).length);
      setRendered(true);
    } catch (err) {
      console.error("Error generating ID cards:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="container">
        <div className="select-container">
          <select
            onChange={(e) => {
              const [id, cname] = e.target.value.split(" ");
              setClassID(id);
              setStd(cname);
            }}
            className="select__box"
          >
            <option value="">Select Class</option>
            {classes.map((cls) => (
              <option key={cls.id} value={`${cls.id} ${cls.class_name}`}>
                {cls.class_name}
              </option>
            ))}
          </select>
          <select
            onChange={(e) => {
              const [id, dname] = e.target.value.split(" ");
              setDivID(id);
              setDivName(dname);
              setStudentCount(null);
              setTotalIdCards(null);
            }}
            className="select__box"
          >
            <option value="">Select Div</option>
            {divisions.map((div) => (
              <option key={div.id} value={`${div.id} ${div.div_name}`}>
                {div.div_name}
              </option>
            ))}
          </select>
        </div>

        {loading ? (
          <Loader type="ThreeDots" color="#111" height={80} width={80} />
        ) : (
          <button onClick={generateIdCards} className="btn__check">
            Check
          </button>
        )}

        {!rendered ? (
          <p className="message">
            Download ID cards if they are available; otherwise, please apply
            first.
          </p>
        ) : (
          <>
            {studentCount !== null && (
              <p
                className="message"
                style={{ fontFamily: "monospace", fontSize: 22 }}
              >
                Total Students: {studentCount || "Not available"}
              </p>
            )}

            {totalIdCards !== null && (
              <p
                className="message"
                style={{ fontFamily: "monospace", fontSize: 22 }}
              >
                Total ID cards: {totalIdCards || "Not available"}
              </p>
            )}

            {totalIdCards > 0 &&
              (downloading ? (
                <p
                  style={{
                    fontFamily: "monospace",
                    fontWeight: "bold",
                    fontSize: 24,
                  }}
                >
                  ...Downloading
                </p>
              ) : (
                <button onClick={downloadImagesAsZip} className="btn__check">
                  Download
                </button>
              ))}
          </>
        )}
      </div>
    </>
  );
};

export default DownLoadMultiple;
